import React, { FC } from 'react'
import classnames from 'classnames'

import style from './Divider.module.css'

interface IDividerProps {
  className?: string
}

export const Divider: FC<IDividerProps> = ({ className }) => {
  const classNames = classnames(style.divider, className)

  return <div className={classNames} />
}

Divider.displayName = 'Divider'
